import { AdditionalInfo } from '../../pages';
import React, { useState } from 'react';

const AdditionalInfoContainer = ({ closeModal }) => {
	const [modalInfo, setModalInfo] = useState(false);
	const goToModalInfo = () => {
		setModalInfo(!modalInfo);
	};

	return (
		<AdditionalInfo
			modalInfo={modalInfo}
			goToModalInfo={goToModalInfo}
			closeModal={closeModal}
		/>
	);
};

export default AdditionalInfoContainer;
